import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <div>
        <footer className="main-footer">
          <strong>
            Copyright &copy; 2024 <a href="#">TOPUP CONNECT</a>
          </strong>
        </footer>
      </div>
    );
  }
}
